import {tokens as dark} from '../../../generated/dark';
import {tokens as light} from '../../../generated/light';

export const sizes = {
  xs: {
    gap: `${light.components.buttons[`gutter-xs`]}`,
    height: `${light.components.buttons[`height-xs`]}`,
    padding: `${light.components.buttons[`padding-xs`]}`,
  },

  sm: {
    gap: `${light.components.buttons[`gutter-sm`]}`,
    height: `${light.components.buttons[`height-sm`]}`,
    padding: `${light.components.buttons[`padding-sm`]}`,
  },

  md: {
    gap: `${light.components.buttons[`gutter-md`]}`,
    height: `${light.components.buttons[`height-md`]}`,
    padding: `${light.components.buttons[`padding-md`]}`,
  },

  lg: {
    gap: `${light.components.buttons[`gutter-lg`]}`,
    height: `${light.components.buttons[`height-lg`]}`,
    padding: `${light.components.buttons[`padding-lg`]}`,
  },
};

export const primary = {
  light: light.components.buttons.primary,
  dark: dark.components.buttons.primary,
};

export const primaryDanger = {
  light: light.components.buttons.danger,
  dark: dark.components.buttons.danger,
};

export const secondary = {
  light: light.components.buttons.secondary,
  dark: dark.components.buttons.secondary,
};

export const secondaryDanger = {
  light: light.components.buttons[`danger-secondary`],
  dark: dark.components.buttons[`danger-secondary`],
};

export const tertiary = {
  light: light.components.buttons.tertiary,
  dark: dark.components.buttons.tertiary,
};

export const link = {
  light: light.components.buttons[`button-link`].default,
  dark: dark.components.buttons[`button-link`].default,
};

export const linkDanger = {
  light: light.components.buttons[`button-link`].danger,
  dark: dark.components.buttons[`button-link`].danger,
};

export const linkWarning = {
  light: light.components.buttons[`button-link`].warning,
  dark: dark.components.buttons[`button-link`].warning,
};

export const outline = {
  light: light.components.buttons.outline,
  dark: dark.components.buttons.outline,
};

export const subtle = {
  light: light.components.buttons.subtle,
  dark: dark.components.buttons.subtle,
};
